import React from "react";
import { Modal, Button } from "react-bootstrap";

// Define TeamMember interface here
interface TeamMember {
  id: number;
  name: string;
  designation: string;
  department: string;
  image: string;
  description: string;
  sequence: number;
  linkedin: string;
  portfolio: string;
  twitter: string;
}

interface TeamMemberDetailsModalProps {
  show: boolean;
  onHide: () => void;
  member: TeamMember | null;
}

const TeamMemberDetailsModal: React.FC<TeamMemberDetailsModalProps> = ({ show, onHide, member }) => {
  if (!member) return null;

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header className="d-flex justify-content-between align-items-start">
  <Modal.Title>{member.name}'s Details</Modal.Title>
  <button type="button" className="btn-close" aria-label="Close" onClick={onHide}></button>
</Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-column flex-md-row gap-4">
          <div
            style={{
              width: "120px",
              height: "120px",
              borderRadius: "8px",
              overflow: "hidden",
              border: "1px solid #ddd",
              backgroundColor: "#f8f9fa",
            }}
          >
            <img
              src={`${process.env.REACT_APP_API_URL}${member.image}`}
              alt={member.name}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src =
                  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 24 24'%3E%3Cpath fill='%23999' d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'/%3E%3C/svg%3E";
              }}
            />
          </div>

          <div className="flex-grow-1">
            <p><strong>Name:</strong> {member.name}</p>
            <p><strong>Designation:</strong> {member.designation}</p>
            <p><strong>Department:</strong> {member.department}</p>
            <p><strong>Description:</strong> {member.description}</p>
            <p><strong>Sequence:</strong> {member.sequence}</p>

            {member.linkedin && (
              <p>
                <strong>LinkedIn:</strong>{" "}
                <a href={member.linkedin} target="_blank" rel="noopener noreferrer">
                  {member.linkedin}
                </a>
              </p>
            )}
            {member.portfolio && (
              <p>
                <strong>Portfolio:</strong>{" "}
                <a href={member.portfolio} target="_blank" rel="noopener noreferrer">
                  {member.portfolio}
                </a>
              </p>
            )}
            {member.twitter && (
              <p>
                <strong>Twitter:</strong>{" "}
                <a href={member.twitter} target="_blank" rel="noopener noreferrer">
                  {member.twitter}
                </a>
              </p>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TeamMemberDetailsModal;
